const API = process.env.REACT_APP_BACKEND_URL;
const VID_KEY = 'app_vid';

function visitorId() {
  try {
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
      const bytes = new Uint8Array(16);
      (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(bytes) : bytes.forEach((_, i) => { bytes[i] = Math.floor(Math.random() * 256); });
      vid = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
      localStorage.setItem(VID_KEY, vid);
    }
    return vid;
  } catch { return ''; }
}

export function track(event, path, meta = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (navigator.webdriver) return;
    const p = path || window.location.pathname;
    if (p.startsWith('/admin')) return;
    const payload = {
      event, path: p, vid: visitorId(), width: window.innerWidth, meta: meta || {},
      referrer: event === 'pageview' ? (document.referrer || '') : '',
    };
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/track`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/api/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch { /* fire-and-forget */ }
}
